import { Autocomplete, Skeleton, TextField } from '@mui/material'

type ValueBase = string | number

export interface Option<T extends ValueBase> {
  value: T
  label: string
}

export interface SelectSubscriptionPlanProps<T extends ValueBase> {
  value: string | undefined
  options: Option<T>[]
  onSelect: (value: T) => void
  disabled?: boolean
}

export const SelectSubscriptionPlan = <T extends ValueBase>({ value, options, onSelect, disabled }: SelectSubscriptionPlanProps<T>) => (
  <Autocomplete
    value={options.find((o) => o.value === value) ?? { value: '' as T, label: '' }}
    options={options}
    getOptionLabel={(option) => option.label}
    isOptionEqualToValue={(option, val) => option.value === val.value}
    disableClearable
    disabled={disabled}
    onChange={(_, option) => {
      if (option) onSelect(option.value)
    }}
    renderInput={(params) => <TextField {...params} />}
  />
)

const SelectSubscriptionPlanSkeleton = () => <Skeleton data-testid="loading-skeleton" variant="rounded" height={48} />
const SelectSubscriptionPlanTemplateSkeleton = () => <Skeleton data-testid="loading-skeleton" variant="rounded" height={16.8} width={160} />

SelectSubscriptionPlan.SelectSkeleton = SelectSubscriptionPlanSkeleton
SelectSubscriptionPlan.TemplateSkeleton = SelectSubscriptionPlanTemplateSkeleton
